module.exports = __webpack_public_path__ + "img/1.87bfac78.jpg";